import React, { useContext } from "react";
import "../AccountMaintenance.css";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import Loader from "../../../../components/element/Loader";
import ErrorPopup from "../../../../components/element/ErrorPopup";
import { FormOutlined, DeleteOutlined } from "@ant-design/icons";
import { ACCOUNT_ROLE_STATUS } from "../../../../utils/constants";
import { getAirportCode } from "../../../../utils/utils";
import { StorageContext } from "../../../../services/StorageProvider";

const AccountUpdateTable = ({
  accountUpdateData,
  isLoading,
  error,
  onClickEdit,
  onClickDelete,
}) => {
  const { userProfileData } = useContext(StorageContext);
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (accountUpdateData && accountUpdateData.length === 0) {
    return <NoDataPlaceholder />;
  }

  const isOwnAccount = (item) => {
    return userProfileData?.id && item?.profileId === userProfileData?.id;
  };

  return (
    <div className="account-maintenance-table-parent-container">
      <div className="account-maintenance-table-container">
        <table className="account-maintenance-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Airline Name</th>
              <th>Name</th>
              <th>Email</th>
              <th>Account Type</th>
              <th>Airport Access</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accountUpdateData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item?.airlineName}</td>
                <td>{`${item?.firstName} ${item?.lastName}`}</td>
                <td>{item?.email}</td>
                <td>
                  {
                    ACCOUNT_ROLE_STATUS.find(
                      (status) => status.value === item?.role
                    )?.name
                  }
                </td>
                <td>
                  {item?.airports
                    .map((airport) => getAirportCode(airport))
                    .join(", ")}
                </td>
                <td>
                  <div className="account-update-table-action-container">
                    <div
                      className="account-update-table-action account-update-table-edit"
                      onClick={() => onClickEdit(item)}
                    >
                      <FormOutlined />
                    </div>
                    <div
                      className={`account-update-table-action account-update-table-delete ${
                        isOwnAccount(item) ? "disabled" : ""
                      }`}
                      onClick={() =>
                        isOwnAccount(item) ? null : onClickDelete(item)
                      }
                    >
                      <DeleteOutlined />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccountUpdateTable;
